export const ADDTOCART = 'cart/add';
export const DELETEFROMCART = 'cart/delete';
